(function () {
  'use strict';

  DetectionImageCtrl.$inject = [
    '$timeout',
    '$rootScope',
    'SensorService',
    'AppUtils',
    '$state',
    '$scope',
  ];

  window.angular.module('app').component('detectionImage', {
    controller: DetectionImageCtrl,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      data: '<',
      feedback: '<',
      disableClick: '<',
      onLoadContent: '<',
      zone: '<?',
      copyObjects: '<',
      filterByZone: '<',
      maxHeight: '<',
      disableSpinner: '<',
      showZone: '<',
      imageMode: '<',
      showFigures: '<',
      hideButtons: '<',
    },
    template:'<a style="display: block" ng-class="{\'cursor-pointer\': !ctrl.disableClick}" ng-click="ctrl.expand()" target="_blank"><background-image ng-if="ctrl.imageSrc" image-src="ctrl.imageSrc" on-load-content="ctrl.onLoadImage" image-mode="ctrl.imageMode" dimensions="ctrl.dimensions" max-height="ctrl.maxHeight" disable-spinner="ctrl.disableSpinner"></background-image><div style="position: absolute; width: 100%" ng-style="{top: ctrl.dimensions.offset.top}" ng-if="ctrl.showFigures && ctrl.dimensions.width && ctrl.dimensions.height" class="detection-objects-container"><detection-objects-canvas sensor="ctrl.sensor" data="ctrl.data" image="ctrl.image" draw-zone="ctrl.showZone" filter-by-zone="ctrl.filterByZone" width="ctrl.dimensions.width" height="ctrl.dimensions.height" ratio="ctrl.dimensions.ratio" copy-objects="ctrl.copyObjects"></detection-objects-canvas></div><div class="floating-btn" style="left: 5px" ng-show="ctrl.dimensions.loading === false" ng-if="!ctrl.imageError && !ctrl.hideButtons" data-html2canvas-ignore><div class="btn-group btn-group-xs" ng-click="$event.stopPropagation();"><a class="btn btn-default" style="padding: 1px; font-size: 0.9rem" ng-click="$event.preventDefault(); ctrl.showFigures = !ctrl.showFigures"><span class="fa-stack fa-fw" style="width: 2.5em"><i class="far fa-fw fa-circle fa-stack-2x"></i> <i class="fas fa-fw fa-draw-polygon fa-stack-1x"></i></span></a> <a class="btn btn-default" ng-href="{{ctrl.imageSrc}}" target="_blank"><i class="fas fa-download fa-fw"></i></a></div></div><spinner show="ctrl.loading" css-class="\'small absolute\'" style="opacity: 0.5;"></spinner></a>',
  });

  function DetectionImageCtrl($timeout, $root, SensorService, utils, $state, $scope) {
    let vm = this;
    let firstChange = true;

    vm.$onInit = function () {
      vm.onLoadImage = onLoadImage;
      vm.dimensions = {};

      vm.state = $state.get().reduce((filtered, current) => {
        const name = current.name;
        const component = current.component;
        if (name.includes('dataDisplay') && component === 'monitoringDataDisplay') {
          filtered.push(current);
        }
        return filtered;
      }, [])[0];

      vm.expand = expand;

      vm.showFigures = vm.showFigures == null ? true : vm.showFigures;
      vm._classes = typeof vm.showFigures === 'boolean' ? null : vm.showFigures.split();
      vm.showFigures = !!vm.showFigures;
      init();

      $scope.$watch('ctrl.imageSrc', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (vm.timeout) {
            $timeout.cancel(vm.timeout);
          }

          vm.timeout = $timeout(() => {
            vm.loading = true;
          }, 300);
        }
      });
    };

    vm.$onChanges = function (changes) {
      if (firstChange) {
        firstChange = false;
        return;
      }

      if (changes.showFigures) {
        vm.showFigures = vm.showFigures == null ? true : vm.showFigures;
        vm._classes = typeof vm.showFigures === 'boolean' ? null : vm.showFigures.split();
        vm.showFigures = !!vm.showFigures;
      }

      init();
    };

    function init() {
      $timeout(() => {
        vm.showFigures = typeof vm.showFigures === 'boolean' ? vm.showFigures : true;
        vm.showZone = typeof vm.showZone === 'boolean' ? vm.showZone : true;
        vm.disableSpinner = typeof vm.disableSpinner === 'boolean' ? vm.disableSpinner : false;
        if (!vm.sensor || !vm.data) {
          return;
        }

        vm.filterByZone = vm.filterByZone !== false;
        vm.content = vm.feedback ? vm.data.feedback : vm.data.content;

        if (vm.data && vm.content) {
          vm.imageSrc = getImageUrl(vm.data);
        }
      });
    }

    function updateDetectionsAndConfig() {
      vm.objects = vm.content.objects || vm.content.faces || vm.content.detections;
      vm.objects = vm.objects || [];
      vm.pairs = vm.data.content.pairs ? vm.data.content.pairs : null;
      vm.poses = vm.content.poses || [];

      if (vm._classes && vm._classes.length) {
        vm.objects = vm.objects.filter((c) => vm._classes.indexOf(c.class) !== -1);
      }

      const lineTypes = ['CrossLineMultiRecognition'];

      vm.zones = [];
      if (
        vm.sensor.parameters &&
        vm.sensor.parameters.points &&
        vm.sensor.parameters.points.length
      ) {
        let parameters = JSON.parse(JSON.stringify(vm.sensor.parameters));
        parameters.id = utils.generateUUID();
        parameters.sensorId = vm.sensor.id;
        vm.zones = [parameters];
      }

      if (lineTypes.indexOf(vm.sensor.type) !== -1) {
        vm.drawType = 'line';
      } else {
        vm.drawType = 'polygon';
      }
    }

    function onLoadImage(err, image) {
      vm.loading = false;
      if (vm.timeout) {
        $timeout.cancel(vm.timeout);
      }

      if (vm.onLoadContent) {
        vm.onLoadContent(err, image);
      }

      vm.image = err ? null : image;
      vm.imageError = err;
      if (!err) {
        updateDetectionsAndConfig();
      }
    }

    function getImageUrl(data) {
      if (!data || !data.content) {
        return;
      }

      const content = data.content;
      let image;
      if (vm.content?.files) {
        image = content.files.gif ? content.files.gif : content.files.image;
        image = Array.isArray(image) ? image[0] : image;
      }

      if (!image || !image.container || !image.name) {
        return;
      }

      vm.container = image.container;
      vm.imageName = image.name;

      return SensorService.getImageUrl(vm.sensor.id, image, data.from);
    }

    function expand() {
      if (vm.disableClick) {
        return;
      }

      const dataId = vm.data.referenceId || vm.data.id;
      window.open(
        $state.href(
          vm.state,
          {
            projectId: $root.projectId,
            assetId: vm.sensor.assetId,
            sensorId: vm.sensor.id,
            dataId: utils.isDate(dataId) ? dataId.getTime() : dataId,
            zoneFilter: vm.filterByZone,
          },
          '_blank'
        )
      );
    }
  }
})();
